import React from 'react';

interface Step {
  number: string;
  title: string;
  description: string;
}

const steps: Step[] = [
  {
    number: '01',
    title: 'Create your workflow',
    description:
      'Design your form(s), assign responsibilities to your team, and choose your working schedule. Create security deposit policies, appointment reminders and more.',
  },
  {
    number: '02',
    title: 'Share your page link',
    description:
      'Let the user visit your page and fill out the form. Your automated workflow will take care of the rest.',
  },
  {
    number: '03',
    title: 'Book & manage',
    description:
      'Clients book appointments through your page and pay their deposit. InkVoyd tracks every booking and sends automatic reminders so no appointment slips through.',
  },
];

const LandingHowItWorks: React.FC = () => {
  return (
    <section id="how" className="mx-auto max-w-6xl px-5 py-16">
      <div className="rounded-3xl bg-white/90 p-8 shadow-2xl">
        <h2 className="text-2xl font-bold text-[#2f2f2d]">How it works</h2>
        <div className="mt-6 grid grid-cols-1 gap-6 md:grid-cols-3">
          {steps.map((step) => (
            <div key={step.number} className="rounded-2xl border border-gray-200 p-5">
              <div className="mb-2 text-sm font-semibold text-gray-500">{step.number}</div>
              <h3 className="text-lg font-semibold text-[#2f2f2d]">{step.title}</h3>
              <p className="mt-1 text-sm text-[#2f2f2d]">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LandingHowItWorks;
